
import { profileDetails } from "../../models/model";
import { profileActions } from "../interface/reducerType";

import { Types } from '../action/action';

const initialState = {
  profileData: {},
  isprofile: false,
  userStatusData: "",
  isUserStatus: false,
  emergencyAddressData: {},
  isemergencyAddressData: false,
  isSettings: false,
  isSettingTab: 'profile',
  videoprofileData: {},
  isvideoprofile: false,
  meetingDetails: {},
  isRingvideo: false,
  isVideocallRingvideo: false,
  videomeetingDetails: {},
  isVideoRequestSent: false,
  isDirectVideocall: false,
  directVmCallCount:0
};

export const profileReducer = (state: profileDetails = initialState, action: profileActions) => {
  switch (action.type) {
    case Types.PROFILE_DETAIL:
      return {
        ...state,
        profileData: action.payload.profileData,

        isprofile: action.payload.isprofile

      };
    case Types.USER_STATUS:
      return {
        ...state,
        userStatusData: action.payload.userStatusData,

        isUserStatus: action.payload.isUserStatus
      };
    case Types.EMERGENCY_ADDRESS:
      return {
        ...state,
        emergencyAddressData: action.payload.emergencyAddressData,
        isemergencyAddressData: action.payload.isemergencyAddressData
      };
    case Types.OPEN_SETTINGS:
      return {
        ...state,
        isSettings: action.payload.isSettings, isSettingTab: action.payload.isSettingTab
      };
    case Types.VIDEO_PROFILE_SETTING:
      return {
        ...state,
        videoprofileData: action.payload.videoprofileData, isvideoprofile: action.payload.isvideoprofile
      };
    case Types.VIDEO_MEET_RING_NOTIFICATION:
      return {
        ...state,
        meetingDetails: action.payload.meetingDetails, isRingvideo: action.payload.isRingvideo
      };
    case Types.VIDEO_CALL_REQUEST_NOTIFICATION:
      return {
        ...state,
        videomeetingDetails: action.payload.meetingDetails, isVideocallRingvideo: action.payload.isVideocallRingvideo,
        isDirectVideocall: action.payload.isDirectVideocall
      };
    case Types.VIDEO_CALL_REQUEST_SENT:
      return {
        ...state,
        isVideoRequestSent: action.payload.isVideoRequestSent, videomeetingDetails: action.payload.meetingDetails
      };
      case Types.VIDEO_CALL_REQ_COUNT:
        return {
          ...state,directVmCallCount:action.payload.directVmCallCount
        }  

    default:
      return state;
  }
};